module.exports = __webpack_public_path__ + "static/media/video.9f91eb06.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/video.webm
// module id = 177
// module chunks = 0